import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import * as moment from 'moment-timezone';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { ARMiscInvoiceTypeResultDto } from './ar-misc-invoice-type-result-dto';
const ɵ0 = () => ARMiscInvoiceTypeResultDto, ɵ1 = () => KeyValueResultDto, ɵ2 = () => Date;
export class ARMiscInvoiceEditorResultDto {
    get minPostDate() {
        return !!this.closedBookPeriod ? moment(this.closedBookPeriod).add(1, 'day').toDate() : null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], ARMiscInvoiceEditorResultDto.prototype, "invoiceTypes", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], ARMiscInvoiceEditorResultDto.prototype, "subLedgers", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], ARMiscInvoiceEditorResultDto.prototype, "closedBookPeriod", void 0);
export { ɵ0, ɵ1, ɵ2 };
